import AppRouter from './routers/AppRouter'
import { createTheme, ThemeProvider } from '@material-ui/core/styles'
import {
  AuthContextProvider,
  useAuthentication,
} from './context/authenticationContext'
import { RoutesProvider } from './context/routeContext'
import { OperationsContextProvider } from './context/operationsContext'
import './App.scss'
// import { IFIProvider } from './context/IFIContext'
import 'devextreme/dist/css/dx.common.css'
import 'devextreme/dist/css/dx.light.css'
import 'devexpress-gantt/dist/dx-gantt.css' /* add this line */
import { useIdleTimer } from 'react-idle-timer'
import config from './config/config.json'
import Swal from 'sweetalert2'

const theme = createTheme({
  palette: {
    primary: {
      main: '#014B96',
    },

    secondary: {
      main: '#2bce75',
    },
    danger: {
      main: '#F15454',
    },
    white: {
      main: '#FFFFFF',
    },
  },
  props: {},
})

function App() {
  const urlfront = config.URLFrontend
  const { isAuthenticated } = useAuthentication()

  const onIdle = () => {
    if (isAuthenticated) {
      // Close Modal Prompt
      // Do some idle action like log out your user

      const mensaje = `Vuelva a solicitar acceso al sistema.`
      Swal.fire({
        title: `La sesión ha caducado`,
        text: `${mensaje}`,
        icon: 'info',
        confirmButtonColor: '#28a745',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Entendido',
        allowOutsideClick: false,
        // footer:
        //   '<a href="mailto: comunicacionesCAMBio@bcie.org">Contactar al administrador</a>',
      }).then((result) => {
        if (result.isConfirmed) {
          // setisAuthBackend(false)
          localStorage.removeItem('accessToken')
          localStorage.removeItem('TokenBackend')

          window.location.replace(`${urlfront}`)
        }
      })
    }
  }

  const { isIdle } = useIdleTimer({
    // onPrompt,
    onIdle,
    // onActive,
    // onAction,
    timeout: config.timeOut,
    promptTimeout: 0,
    events: [
      'mousemove',
      'keydown',
      'wheel',
      'DOMMouseScroll',
      'mousewheel',
      'mousedown',
      'touchstart',
      'touchmove',
      'MSPointerDown',
      'MSPointerMove',
      'visibilitychange',
    ],
    immediateEvents: [],
    debounce: 0,
    throttle: 0,
    eventsThrottle: 200,
    element: document,
    startOnMount: true,
    startManually: false,
    stopOnIdle: false,
    crossTab: false,
    name: 'idle-timer',
    syncTimers: 0,
    leaderElection: false,
  })

  console.log('isIdle', isIdle)

  return (
    <ThemeProvider theme={theme}>
      <AuthContextProvider>
        <OperationsContextProvider>
          <RoutesProvider>
            <AppRouter />
          </RoutesProvider>
        </OperationsContextProvider>
      </AuthContextProvider>
    </ThemeProvider>
  )
}

export default App
